import { Injectable } from '@angular/core';

import { BetslipType } from '../../../../../../core/betslip-type';
import { CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostSlipTypeValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.SlipType;

    isValid(_: IRewardToken, state: TokenValidationInput): boolean {
        return state.selectedType === BetslipType.Combo;
    }
}
